import axios from 'axios';
//axios.defaults.withCredentials=true;
//console.log(axios.defaults,789456)
import qs from 'querystring';
export default{
    getPost(url,param){
        try{
            return Promise.race([
                new Promise((resolve, reject) => {
                    let data = qs.stringify(
                        param
                    );
                    axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
                    axios.post( url, data)
                        .then(response => {
                            resolve(response);
                        })
                        .catch(error => {
                            reject(error);
                        })
                }),
                new Promise((resolve, reject)=>{setTimeout(()=>{reject('服务器超时！')}, 50000);})
            ])
            .then((result) => {
                if(result.hasOwnProperty("data") && typeof(result)=='object')
                    return Promise.resolve(result.data);
                else
                    return Promise.reject.data;
            })
            .catch(error=>{
                return Promise.reject.data;
                throw new Error('url>>'+error.toString());
            });
        }catch (e) {
            return false;
        }
    }
}